import { lazy } from 'react';

export { Projects } from './projects';

export const LazyProjects = lazy(() => import('./projects').then((mod) => ({ default: mod.Projects })));
